"use client";

import { useVolumeLeaderboard } from "@/lib/api/leaderboards";
import { useIdentity } from "@/lib/api/session";
import { formatDecimal } from "@/lib/format/amount";
import { boardError, type VolumeEntry } from "@/lib/leaderboards/format";
import { Board, type BoardRow } from "./Board";

/* The site-wide volume board. The platform states a volume per player and
   no token for it, so the figure is shown as the whitelabel shows it — a
   plain number. */
export function VolumeBoard({ initial }: { initial?: VolumeEntry[] }) {
  const board = useVolumeLeaderboard(initial);
  const { identity } = useIdentity();

  const rows: BoardRow[] = (board.data?.data ?? []).map((entry) => ({
    id: entry.account.id,
    nickname: entry.account.isHidden ? "Hidden" : entry.account.nickname,
    isHidden: entry.account.isHidden,
    value: formatDecimal(entry.volume, 2),
    prize: null,
  }));

  return (
    <Board
      title="Wagering volume"
      rows={rows}
      valueLabel="VOLUME"
      loading={board.isPending}
      error={board.isError ? boardError(board.error) : null}
      emptyTitle="No volume recorded"
      emptyBody="The volume board fills as bets settle. Nothing has been wagered into it yet."
      selfId={identity?.id}
    />
  );
}
